import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { PinnedIndexSymbol } from '../index-ticker.interfaces';

@Component({
    selector: 'app-index-watch-dialog',
    templateUrl: './index-watch-dialog.component.html',
    styleUrls: ['./index-watch-dialog.component.scss']
})
export class IndexWatchDialogComponent implements OnInit {
    indexSymbols: PinnedIndexSymbol[];  // Original reference (for saving)
    workingIndexSymbols: PinnedIndexSymbol[];  // Working copy (for display & drag-drop)
    DEFAULT_PRECISION = 2;
    isFirstTimeUser: boolean;
    tutorialGif: string;
    hasChanges: boolean = false;  // Track if order changed

    constructor(
        private dialogRef: MatDialogRef<IndexWatchDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            indexSymbols: PinnedIndexSymbol[];
            isFirstTimeUser: boolean;
            tutorialGif: string;
        }
    ) {
        this.indexSymbols = data.indexSymbols || [];  // Keep original reference
        this.workingIndexSymbols = [...(data.indexSymbols || [])];  // Shallow copy for working
        this.isFirstTimeUser = data.isFirstTimeUser || false;
        this.tutorialGif = data.tutorialGif || '';
    }

    ngOnInit(): void {
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.workingIndexSymbols, event.previousIndex, event.currentIndex);
        this.hasChanges = true;  // Mark that changes were made
    }

    getClass(value: string) {
        if (value && (value.toString().charAt(value.length - 1) === '%')) {
            value = value.slice(0, -1);
        }
        if (+value > 0) {
            return 'text-green';
        } else if (+value < 0) {
            return 'text-negative';
        } else {
            return 'text-black';
        }
    }

    dismissTutorial() {
        this.isFirstTimeUser = false;
        // Don't close the dialog, just hide the tutorial
    }

    preventEvent(event: Event) {
        event.stopPropagation();
        event.preventDefault();
    }

    closeDialog(save: boolean = false) {
        if (save && this.hasChanges) {
            // Apply the working order to the original array
            this.applyOrderToOriginal();
        }
        
        this.dialogRef.close({ 
            dismissTutorial: !this.isFirstTimeUser && this.data.isFirstTimeUser,
            saved: save
        });
    }

    private applyOrderToOriginal() {
        // Clear and repopulate original array with new order
        this.indexSymbols.length = 0;
        this.indexSymbols.push(...this.workingIndexSymbols);
    }
}

